<template>
    <div>
        <h3>展示棚</h3>
        <div>
            <p>
                貸し本棚には「展示棚」という、貸し本棚の本来の機能も備わっています。
                読者様は貸し本棚に掲載されているお気に入り作品を、自分自身の本棚に並べることができます。
                この展示棚は「お気に入り」とは異なり更新通知などは届きませんが、
                読者様の本棚の中で読むことができ、誰かにお勧めすることもできます。
            </p>
            <h4>展示棚を作る</h4>
            <p>
                展示棚を作るためには、貸し本棚にユーザー登録して、アカウント情報からサブドメインが設定されている必要があります。
            </p>
            <p>
                マイページのジャンルから、新規ジャンルを追加してください。
                ジャンルの種別で「展示棚」を選択することで、他の作家様の作品を追加できるジャンルが作成できます。
            </p>
            <p>
                一度「展示棚」を作成すると、あとから「自分棚」に変更することはできません。
            </p>
            <img src="/img/help/read/07.jpg" alt="展示棚を作成する" class="img-thumbnail mb-3">
            <h4>展示棚に作品を追加する</h4>
            <p>
                お気に入りの作品を見つけた場合、長編小説の場合は目次ページで、
                「展示棚に入れる」で作品を追加することができます。
                短編小説の場合は
                <i class="fas fa-book-open"></i>
                アイコンのボタンで展示棚へ追加することができます。
            </p>
            <p>
                展示棚に作品を追加しても、作家様にはわかりません。
                展示棚から作品を外しても、作家様には伝わりません。
                気兼ねなくご自身の展示棚を編集することができます。
            </p>
            <p>
                １つの展示棚に追加できる小説は {{ $store.state.max_hondana }} 冊までです。
                多くの作品を展示するには、展示棚を増やしてください。
                追加できる展示棚は最大 {{ $store.state.max_genre }} つまでです。
            </p>
            <img src="/img/help/read/06.jpg" alt="展示棚" class="img-thumbnail mb-3">
            <h4>展示棚から作品を外す</h4>
            <p>
                展示棚の作品を開いて、長編小説なら目次ページ、短編小説なら作品ページから、
                「展示棚から外す」ボタンで作品を展示棚から削除することができます。
            </p>
            <h4>展示棚を削除する</h4>
            <p>
                展示棚はマイページのジャンルから削除することができます。
                展示棚を削除すると、その棚に登録されていた小説はすべて登録が解除されます。
            </p>
            <h4>展示棚の表示</h4>
            <p>
                展示棚は通常のジャンルと異なり「展示棚」と明示されます。
                また作品レイアウトもポータルに準じたデザインとなり、
                作者名が表示され、
                スマホレイアウトでは横にスクロールします。
            </p>
            <h4>非表示作品</h4>
            <p>
                公開範囲が「非表示」になっている作品も展示棚に追加することができますが、
                展示棚に表示されることはありません（展示件数には追加されます）。
                非表示作品を展示棚に追加することはお勧めできません。
            </p>
            <h4>展示棚のメリット</h4>
            <p>
                展示棚に作品を集積することで、お気に入りの作品をご自身のサブドメイン下で読むことができます。
                また作品を誰かに紹介したいときに利用することができます。
                本来の「貸し本棚」に似た扱いができます。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "貸し本棚の使い方 | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>